import { Controller } from "@hotwired/stimulus";

const ANSWER_NAME = "assessment_item_response[answer_index]";
const CONFIDENCE_NAME = "assessment_item_response[confidence]";

export default class extends Controller {
  static targets = [
    "choice",
    "strikeButton",
    "strikeInput",
    "submitButton",
    "requirementAnnouncement",
  ];

  connect() {
    this.strikeInputTargets.forEach((input) => {
      this.applyStrike(input.value, input.checked);
    });
    this.updateSubmitState();
  }

  updateSubmitState(event) {
    if (!this.hasSubmitButtonTarget) return;

    const answer = this.element.querySelector(
      `input[name='${ANSWER_NAME}']:checked`,
    );
    const confidence = this.element.querySelector(
      `input[name='${CONFIDENCE_NAME}']:checked`,
    );
    this.submitButtonTarget.disabled = !(answer && confidence);

    if (event?.target) {
      this.announceRequirements(
        event.target,
        Boolean(answer),
        Boolean(confidence),
      );
    }
  }

  announceRequirements(changedInput, hasAnswer, hasConfidence) {
    if (!this.hasRequirementAnnouncementTarget) return;

    const name = changedInput.getAttribute("name") || "";
    let message = "";

    if (name === ANSWER_NAME && hasAnswer && !hasConfidence) {
      message = "Select your level of certainty before submitting.";
    } else if (name === CONFIDENCE_NAME && hasConfidence && !hasAnswer) {
      message = "Select an answer before submitting.";
    }

    this.requirementAnnouncementTarget.textContent = message;
  }

  toggleStrike(event) {
    event.preventDefault();
    const index = event.currentTarget.dataset.index;
    const input = this.inputFor(index);
    if (!input) return;

    input.checked = !input.checked;
    this.applyStrike(index, input.checked);
  }

  applyStrike(index, struck) {
    const choice = this.choiceTargets.find(
      (el) => el.dataset.index === String(index),
    );
    const button = this.strikeButtonTargets.find(
      (el) => el.dataset.index === String(index),
    );

    choice?.classList.toggle("line-through", struck);
    button?.setAttribute("aria-pressed", struck ? "true" : "false");
  }

  inputFor(index) {
    return this.strikeInputTargets.find((el) => el.value === String(index));
  }
}
